import { gql } from 'graphql-request'

export const WoolStoreDirectoryGql = gql`
  query woolStoreDirectory {
    woolStoreDirectory {
      email
      label
    }
  }
`
